angular.module('controllers').controller('settingController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog',
    function ($scope, $rootScope, $controller, $http, Crud, $mdDialog) {
        $rootScope.path = '/setting';
        $rootScope.modelName = 'setting';
        $scope.path = $rootScope.path;
        $scope.pathTemplate = 'app/settings';
        $scope.title = 'Setari';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $rootScope.sortType = 'id';
        $rootScope.typeId = 'id';
        $scope.additionals = [];
        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.message = '';
        $scope.classAction = 'td-big';

        $scope.additionals['searchTerm'];
        $scope.additionals['clearSearchTerm'] = function() {
            $scope.additionals['searchTerm'] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.getDependedFields = function () {
            Crud.getDependedFields($scope.path)
                .success(function (data) {
                    $scope.additionals['food_categories'] = data['food_categories'];
                });
        }

        $scope.getSettings = function () {
            $scope.additionals['invalid'] = '';
            Crud.get($scope.path+'/index')
                .success(function (data) {
                    if (!angular.isUndefined(data[0])) {
                        $scope.modelData = data[0];

                        if(data[0]['enable_calls'] == 0) {
                            $scope.modelData.enable_calls = false;
                        }
                        if(data[0]['enable_calls'] == 1) {
                            $scope.modelData.enable_calls = true;
                        }

                        if(data[0]['enable_route_animation'] == 0) {
                            $scope.modelData.enable_route_animation = false;
                        }
                        if(data[0]['enable_route_animation'] == 1) {
                            $scope.modelData.enable_route_animation = true;
                        }
                        if(data[0]['enable_direction_animation'] == 0) {
                            $scope.modelData.enable_direction_animation = false;
                        }
                        if(data[0]['enable_direction_animation'] == 1) {
                            $scope.modelData.enable_direction_animation = true;
                        }
                        /* prints */
                        if(data[0]['enable_prints'] == 0) {
                            $scope.modelData.enable_prints = false;
                        }
                        if(data[0]['enable_prints'] == 1) {
                            $scope.modelData.enable_prints = true;
                        }

                        if(data[0]['enable_prints_bc'] == 0) {
                            $scope.modelData.enable_prints_bc = false;
                        }
                        if(data[0]['enable_prints_bc'] == 1) {
                            $scope.modelData.enable_prints_bc = true;
                        }

                        if(data[0]['enable_prints_bf'] == 0) {
                            $scope.modelData.enable_prints_bf = false;
                        }
                        if(data[0]['enable_prints_bf'] == 1) {
                            $scope.modelData.enable_prints_bf = true;
                        }

                        if(data[0]['enable_prints_np'] == 0) {
                            $scope.modelData.enable_prints_np = false;
                        }
                        if(data[0]['enable_prints_np'] == 1) {
                            $scope.modelData.enable_prints_np = true;
                        }
                        /* end prints */

                        if(data[0]['enable_imports'] == 0) {
                            $scope.modelData.enable_imports = false;
                        }
                        if(data[0]['enable_imports'] == 1) {
                            $scope.modelData.enable_imports = true;
                        }

                        if(data[0]['enable_product_discounts'] == 0) {
                            $scope.modelData.enable_product_discounts = false;
                        }
                        if(data[0]['enable_product_discounts'] == 1) {
                            $scope.modelData.enable_product_discounts = true;
                        }
                        if(data[0]['enable_client_discounts'] == 0) {
                            $scope.modelData.enable_client_discounts = false;
                        }
                        if(data[0]['enable_client_discounts'] == 1) {
                            $scope.modelData.enable_client_discounts = true;
                        }
                        if(data[0]['enable_order_discounts'] == 0) {
                            $scope.modelData.enable_order_discounts = false;
                        }
                        if(data[0]['enable_order_discounts'] == 1) {
                            $scope.modelData.enable_order_discounts = true;
                        }

                        if(data[0]['enable_packaging'] == 0) {
                            $scope.modelData.enable_packaging = false;
                        }
                        if(data[0]['enable_packaging'] == 1) {
                            $scope.modelData.enable_packaging = true;
                        }

                        if(data[0]['enable_loyalty_points'] == 1) {
                            $scope.modelData.enable_loyalty_points = true;
                        }
                    }
                    $scope.getDependedFields();
                });
        }

        $scope.theme_options = [
            {'id':'light-gray', 'value':'Light Gray'},
            {'id':'light-blue', 'value':'Light Blue'},
            {'id':'light-red', 'value':'Light Red'}
        ];

        $scope.max_widths = [
            {'id' : '40', 'value' : '40%'},
            {'id' : '50', 'value' : '50%'},
            {'id' : '60', 'value' : '60%'}
        ];

        if (angular.isUndefined($scope.modelData['theme'])) {
            $scope.modelData['theme'] = $scope.theme_options[0].id;
        }
        if (angular.isUndefined($scope.modelData['mode_action'])) {
            $scope.modelData['mode_action'] = $scope.mode_action_options[0].id;
        }

        /* save a model */
        $scope.updateModel = function () {
            $scope.additionals['buttonDisabled'] = true;
            $scope.isLoading = true;
            $scope.additionals['invalid'] = '';
            $scope.modelData['route'] = 'store';
            Crud.save($scope.additionals['content_type'], $scope.modelData, $scope.path)
                .success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    } else {
                        if (!angular.isUndefined(data.model)) {
                            $scope.modelData = data.model;
                            if(data.model['enable_calls'] == 0) {
                                $scope.modelData.enable_calls = false;
                            }
                            if(data.model['enable_calls'] == 1) {
                                $scope.modelData.enable_calls = true;
                            }

                            if(data.model['enable_route_animation'] == 0) {
                                $scope.modelData.enable_route_animation = false;
                            }
                            if(data.model['enable_route_animation'] == 1) {
                                $scope.modelData.enable_route_animation = true;
                            }
                            if(data.model['enable_direction_animation'] == 0) {
                                $scope.modelData.enable_direction_animation = false;
                            }
                            if(data.model['enable_direction_animation'] == 1) {
                                $scope.modelData.enable_direction_animation = true;
                            }
                            /* prints */
                            if(data.model['enable_prints'] == 0) {
                                $scope.modelData.enable_prints = false;
                            }
                            if(data.model['enable_prints'] == 1) {
                                $scope.modelData.enable_prints = true;
                            }
                            if(data.model['enable_prints_bc'] == 0) {
                                $scope.modelData.enable_prints_bc = false;
                            }
                            if(data.model['enable_prints_bc'] == 1) {
                                $scope.modelData.enable_prints_bc = true;
                            }
                            if(data.model['enable_prints_np'] == 0) {
                                $scope.modelData.enable_prints_np = false;
                            }
                            if(data.model['enable_prints_np'] == 1) {
                                $scope.modelData.enable_prints_np = true;
                            }
                            if(data.model['enable_prints_bf'] == 0) {
                                $scope.modelData.enable_prints_bf = false;
                            }
                            if(data.model['enable_prints_bf'] == 1) {
                                $scope.modelData.enable_prints_bf = true;
                            }
                            /* end prints */

                            if(data.model['enable_imports'] == 0) {
                                $scope.modelData.enable_imports = false;
                            }
                            if(data.model['enable_imports'] == 1) {
                                $scope.modelData.enable_imports = true;
                            }

                            if(data.model['enable_product_discounts'] == 0) {
                                $scope.modelData.enable_product_discounts = false;
                            }
                            if(data.model['enable_product_discounts'] == 1) {
                                $scope.modelData.enable_product_discounts = true;
                            }
                            if(data.model['enable_client_discounts'] == 0) {
                                $scope.modelData.enable_client_discounts = false;
                            }
                            if(data.model['enable_client_discounts'] == 1) {
                                $scope.modelData.enable_client_discounts = true;
                            }
                            if(data.model['enable_order_discounts'] == 0) {
                                $scope.modelData.enable_order_discounts = false;
                            }
                            if(data.model['enable_order_discounts'] == 1) {
                                $scope.modelData.enable_order_discounts = true;
                            }

                            if(data.model['enable_packaging'] == 0) {
                                $scope.modelData.enable_packaging = false;
                            }
                            if(data.model['enable_packaging'] == 1) {
                                $scope.modelData.enable_packaging = true;
                            }

                            if(data.model['enable_loyalty_points'] == 1) {
                                $scope.modelData.enable_loyalty_points = true;
                            }
                        }
                        $rootScope.theme = data.model['theme'];
                        $rootScope.mode_action = data.model['mode_action'];
                        $rootScope.currency = data.model['currency'];
                    }
                    $scope.isLoading = false;
                    $scope.errors = {};
                    $scope.additionals['buttonDisabled'] = false;

                })
                .error(function (data) {
                    $scope.isLoading = false;
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                });
        };


    }]
)
